import { InputLabel, Select, MenuItem, FormControl } from '@material-ui/core'
import StatusButton from '../StatusButton'
import { useStyles } from './styles'
const SiteStatusDropDown = (props) => {
  const { status, setStatus, ...rest } = props
  const classes = useStyles()
  const dropDownOptions = [
    {
      key: 'submitted',
      value: 'Submitted For Review',
      color: '#CFC338',
    },
    {
      key: 'rejected',
      value: 'Rejected',
      color: '#FF6565',
    },
    {
      key: 'approved',
      value: 'Approved',
      color: '#35C37D',
    },
    {
      key: 'unenrolled',
      value: 'Unenrolled',
      color: '#CBCBCB',
    }
  ]
  const getStatusText = (status) => {
    switch (status) {
      case 'submitted':
        return 'Submitted For Review'
      case 'rejected':
        return 'Rejected'
      case 'approved':
        return 'Approved'
      case 'unenrolled':
        return 'Unenrolled'
      default:
        return 'Submitted For Review'
    }
  }
  return (
    <div className={classes.layout}>
      <FormControl className={classes.formControl}>
        {' '}
        <InputLabel id="label">Show Applications:</InputLabel>
        <Select
          labelid="label"
          id="site"
          name="siteid"
          classes={{ root: classes.root }}
          {...rest}
          onChange={(event) => { }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          value={getStatusText(status)}
        >
          {dropDownOptions.map((option) => {
            return (
              <MenuItem
                key={option.key}
                value={option.value}
                onClick={() => {
                  setStatus(option.key)
                  props.setPage(1)
                }}
              >
                <StatusButton
                  color={option.color}
                  text={option.value}
                  noborder={true}
                ></StatusButton>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </div>
  )
}
export default SiteStatusDropDown
